import React from 'react';
import { useNavigate } from 'react-router-dom';
import AITemplateRecommender from '../components/AITemplateRecommender';
import Header from '../components/Header';
import Footer from '../components/Footer';

const AIResumeRecommendation = () => {
  const navigate = useNavigate();

  const handleTemplatesRecommended = (templateIds) => {
    console.log('Recommended templates:', templateIds);
    // You can store this in context or state if needed
  };

  const handleSelectTemplate = (template, resumeContent, conversationHistory) => {
    console.log('Selected template:', template);
    console.log('AI-generated resume content:', resumeContent);
    // Navigate to the resume builder with the selected template and AI-generated resume data
    // Set currentStep to 'editor' so it goes directly to the editor
    navigate('/resume-builder', { 
      state: { 
        selectedTemplate: template,
        resumeContent: resumeContent, // AI-generated resume data
        conversationHistory: conversationHistory, // Store conversation for reference
        currentStep: 'editor'
      } 
    });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <AITemplateRecommender
          onTemplatesRecommended={handleTemplatesRecommended}
          onSelectTemplate={handleSelectTemplate}
        />
      </main>
      <Footer />
    </div>
  );
};

export default AIResumeRecommendation;

